import { useNavigate } from "react-router-dom";
import { METRIC, unitPref, setUnitPref } from "@/lib/units";
import { Table2, BookOpen, History, UserRound, PlayCircle, LayoutGrid, ChevronRight, MessageSquare, Star, Truck, FileSearch, Ruler, ShieldCheck, Info, Lock, Heart } from "lucide-react";
import { Screen } from "@/components/kit";
import { useLang } from "@/lib/i18n";
import { setSimple } from "@/lib/simple";
import { useAuth } from "@/context/AuthContext";
import { BigTextRow } from "@/components/BigTextRow";

function Row({ Icon, title, sub, onClick, testid }) {
  return (
    <button type="button" className="more-row" data-testid={testid} onClick={onClick}>
      <Icon size={26} className="more-icon" />
      <span className="more-text"><span className="more-title">{title}</span><span className="card-sub">{sub}</span></span>
      <ChevronRight size={20} />
    </button>
  );
}

export default function MorePage() {
  const nav = useNavigate();
  const { t, lang } = useLang();
  const { user } = useAuth();
  const full = () => { setSimple(false); nav("/"); };
  return (
    <Screen testID="more-screen" title={t("More")} subtitle={t("Everything else in the app")}>
      <div className="more-list">
        <BigTextRow t={t} />
        <Row testid="more-verify" Icon={ShieldCheck} title={t("Quick-verify a drop")} sub={t("Stick, metered gallons and diameter to the level after the drop")} onClick={() => nav("/verify")} />
        <Row testid="more-measure" Icon={Ruler} title={t("Measure an unknown tank")} sub={t("Size from a bottom stick reading and the manway spacing")} onClick={() => nav("/measure")} />
        <Row testid="more-ust" Icon={FileSearch} title={t("Look up this store's tanks")} sub={t("Tank sizes and in-service status from EPA permits")} onClick={() => nav("/ust")} />
        <Row testid="more-load" Icon={Truck} title={t("Load the truck")} sub={t("Split an order into the trailer's pockets")} onClick={() => nav("/load")} />
        <Row testid="more-sites" Icon={History} title={t("My stations & past drops")} sub={t("Saved stations and drop history")} onClick={() => nav("/sites")} />
        <Row testid="more-chart" Icon={Table2} title={t("Tank chart")} sub={t("Inches to gallons, line by line")} onClick={() => nav("/chart")} />
        <Row testid="more-tanks" Icon={BookOpen} title={t("Tank sizes")} sub={t("Search standard tanks by size or maker")} onClick={() => nav("/tanks")} />
        <Row testid="more-video" Icon={PlayCircle} title={t("How-to video")} sub={t("Watch a short video on using the app")}
          onClick={() => window.open(lang === "es" ? "/tutorial-es.mp4" : "/tutorial-en.mp4", "_blank")} />
        <Row testid="more-account" Icon={UserRound} title={user ? t("My account") : t("Sign in")} sub={user ? user.email : t("Save your stations on any phone")}
          onClick={() => nav(user ? "/account" : "/login")} />
        <div className="card more-units">
          <div className="label">{t("Units")}</div>
          <select className="text-input load-select" value={unitPref()} onChange={(e) => setUnitPref(e.target.value)} data-testid="more-units-select">
            <option value="auto">{t("Automatic (by country)")} — {METRIC ? t("metric") : t("US gallons")}</option>
            <option value="us">{t("US: gallons, inches, pounds")}</option>
            <option value="metric">{t("Metric: liters, centimeters, kilograms")}</option>
          </select>
        </div>
        <Row testid="more-about" Icon={Info} title={t("About Fuel Hauler Pro")} sub={t("Who built it, why, and how to reach us")} onClick={() => nav("/about")} />
        <Row testid="more-guide" Icon={BookOpen} title={t("How-to guide")} sub={t("Step by step: stick, chart, drop and scans")} onClick={() => nav("/guide")} />
        <Row testid="more-faq" Icon={Info} title={t("FAQ")} sub={t("Common questions about the app")} onClick={() => nav("/faq")} />
        <Row testid="more-donate" Icon={Heart} title={t("Donate")} sub={t("Keep Fuel Hauler Pro free")} onClick={() => nav("/donate")} />
        <Row testid="more-privacy" Icon={Lock} title={t("Privacy policy")} sub={t("What we collect, photos and payments")} onClick={() => nav("/privacy")} />
        <Row testid="more-reviews" Icon={Star} title={t("Driver reviews")} sub={t("Read reviews or write your own")} onClick={() => nav("/reviews")} />
        <Row testid="more-help" Icon={MessageSquare} title={t("Ask for help")} sub={t("Chat with the helper or send the developer a question")} onClick={() => window.dispatchEvent(new Event("open-help"))} />
        <Row testid="more-full-app" Icon={LayoutGrid} title={t("Switch to the full app")} sub={t("Shows every tool and option")} onClick={full} />
      </div>
    </Screen>
  );
}
